import axiosInstance from '../api/axiosInstance';

export interface ChatWidget {
  id: number;
  key: string;
  color: string;
  textColor?: string;
  widgetSize?: string;
  position?: string;
  borderRadius?: string;
  companyName?: string;
  websiteUrl?: string;
  isActive: boolean;
  autoOpen?: boolean;
  autoDelay?: boolean;
  typingIndicator?: boolean;
  soundNotifications?: boolean;
  headerText?: string | null;
  welcomeMessage?: string | null;
  offlineMessage?: string | null;
  inputPlaceholder?: string | null;
  buttonText?: string | null;
  name?: string;
  createdAt?: string;
  status?: string;
}

export const chatIntegrationAPI = {
  getChatWidgets: async (): Promise<ChatWidget[]> => {
    const response = await axiosInstance.get<ChatWidget[]>('/widgets');
    return response.data;
  },
  getChatWidgetById: async (widgetId: number | string): Promise<ChatWidget> => {
    const response = await axiosInstance.get<ChatWidget>(
      `/widgets/${widgetId}`
    );
    return response.data;
  },
  createChatWidget: async (
    widget: Partial<ChatWidget>
  ): Promise<ChatWidget> => {
    const response = await axiosInstance.post<ChatWidget>('/widgets', widget);
    return response.data;
  },
  updateChatWidget: async (
    widgetId: number,
    widget: ChatWidget
  ): Promise<ChatWidget> => {
    const response = await axiosInstance.put<ChatWidget>(
      `/widgets/${widgetId}`,
      widget
    );
    return response.data;
  },
  updateWidgetStatus: async (
    widgetId: number,
    isActive: boolean
  ): Promise<ChatWidget> => {
    const response = await axiosInstance.put<ChatWidget>(
      `/widgets/${widgetId}`,
      { isActive }
    );
    return response.data;
  },
  deleteChatWidget: async (widgetId: number): Promise<void> => {
    await axiosInstance.delete(`/widgets/${widgetId}`);
  },
};
